import {
  FormGroup,
  InputGroup,
} from "@blueprintjs/core";
import {
  MDBCol,
} from "mdbreact";
import { observer } from "mobx-react";
import * as React from "react";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";

@observer
export default class EmpresaCalculos extends React.Component<{}, {}> {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <MDBCol>

          <div style={{ width: 1000 }}>

            <FormGroup
              label="E-mail Erros de Cálculo"
              labelFor="senha"
              style={{ width: "49%" }}
            >
              <InputGroup
                autoComplete="email-calculos"
                name="email-calculos"
                id="nome-fantasia-off"
                placeholder="email@email.com"
                value={EmpresaStore.obs.empresa_edit.email_calculos}
                onChange={(e: any) => EmpresaStore.obs.empresa_edit.email_calculos = e.target.value}
              />
            </FormGroup>

          </div>

        </MDBCol>

      </>
    );
  }
}
